import Button from "react-bootstrap/Button";

function CHFrBusinessSolutionBody() {
  return (
    <>
      <div className="container-fluid  p-4 body-font">
        <div className="row p-4" style={{ backgroundColor: "ButtonHighlight" }}>
          <div
            className="col-12 col-md-8 mx-auto"
            style={{ position: "relative" }}
          >
            <img
              src="https://images.hertz.com/content/dam/hod/images/de-de/static/BusinessSolution_CH.png"
              alt="Business Solution"
              className="img-fluid"
              style={{ borderRadius: "16px", width: "100%" }}
            />
            <div
              style={{
                position: "absolute",
                top: "3%",
                left: "5%",
                color: "white",
                textShadow: "1px 1px 6px rgba(0,0,0,0.9)",
              }}
            >
              <p className="h6">
                <b>Solutions professionnelles</b>
              </p>
              <h1>
                <i>
                  <b>Votre entreprise en mouvement !</b>
                </i>
              </h1>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12" style={{ textAlign: "center" }}>
            <p className="h2">Solutions professionnelles</p>
            <br />
            <p>
              Hertz 24/7 Business vous offre la manière la plus efficace de gérer les besoins en véhicules de votre entreprise. Nous avons la solution adaptée, que vous soyez une grande entreprise, une PME ou une petite société. Grâce à la technologie primée intégrée dans tous nos véhicules, nous aidons les entreprises à réduire leurs coûts, optimiser l’utilisation des véhicules et améliorer la gestion de leur flotte.
            </p>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-md-6" style={{ textAlign: "center" }}>
            <img
              className="img-fluid"
              src="https://images.hertz.com/content/dam/hod/images/en-gb/static/Corda_Mobile.png"
              alt=""
            />
          </div>
          <div className="col-xs-12 col-md-6" style={{ textAlign: "left" }}>
            <div className="row">
              <div
                className="col-xs-12 col-md-12  py-md-5"
                sstyle={{ textAlign: "left" }}
              >
                <p className="h3">Rentable</p>
                <p>
                  En utilisant une flotte d’entreprise dédiée au car sharing, les entreprises peuvent potentiellement réduire les coûts par rapport au remboursement des déplacements individuels des employés ou à l’utilisation de services tiers.
                </p>
              </div>
            </div>
            <div className="row">
              <div
                className="col-xs-12 col-md-12  py-md-5"
                style={{ textAlign: "left" }}
              >
                <p className="h3">Transparence et contrôle</p>
                <p>
                  Disposer de sa propre flotte permet une meilleure transparence et un meilleur contrôle des opérations de transport. Vous pouvez suivre les habitudes d’utilisation, surveiller la maintenance des véhicules et appliquer plus efficacement les politiques internes.
                </p>
              </div>
            </div>
            <div className="row">
              <div
                className="col-xs-12 col-md-12  py-md-5"
                style={{ textAlign: "left" }}
              >
                <p className="h3">Respectueux de l’environnement</p>
                <p>
                  La mise en place d’une flotte de car sharing en entreprise peut considérablement réduire l’empreinte environnementale des déplacements des employés. Les entreprises peuvent privilégier des véhicules écologiques, comme des voitures hybrides ou électriques, contribuant ainsi à réduire les émissions de carbone et à soutenir les initiatives durables.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12" style={{ textAlign: "center" }}>
            <br />
            <p className="h2">Contactez-nous pour en savoir plus</p>
            <br />
            <p>
              Envoyez-nous un e-mail (<b>✉:salesswitzerland@hertz.ch</b>),
              pour en savoir plus. Un membre de notre équipe dédiée aux flottes d’entreprise vous contactera rapidement.
            </p>
            <br />
            <p>
              <Button href="mailto:salesswitzerland@hertz.ch" variant="warning">
                <b>Envoyer un e-mail</b>
              </Button>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default CHFrBusinessSolutionBody;
